export default __webpack_public_path__ + "static/media/icon-close.fac7763e.svg";